// extracted by mini-css-extract-plugin
module.exports = {"loader":"page-loader-top_loader___poNL"};